import "react-toastify/dist/ReactToastify.css";

import {
  CheckCircleOutline,
  ReportGmailerrorred,
  WarningAmber,
} from "@mui/icons-material";
import { Bounce, ToastContainer, TypeOptions } from "react-toastify";

const CONTAINER_STYLES: Record<TypeOptions, string> = {
  error: "border-red-500",
  success: "border-green-500",
  warning: "border-yellow-500",
  default: "border-none",
  info: "border-none",
};

const Toast = () => {
  return (
    <ToastContainer
      toastClassName={(context) =>
        `${CONTAINER_STYLES[context?.type || "default"]} border-2 bg-gray-800 justify-center flex min-h-12 w-[600px] mt-5 shadow-md text-white rounded-lg px-3 py-2 `
      }
      position="top-center"
      closeButton={false}
      className="w-full justify-items-center"
      autoClose={4000}
      hideProgressBar
      newestOnTop={false}
      pauseOnHover
      bodyClassName="flex items-center gap-1"
      icon={({ type }) => {
        if (type === "success")
          return <CheckCircleOutline className="text-green-400" />;
        if (type === "error")
          return <ReportGmailerrorred className="text-red-400" />;
        if (type === "warning")
          return <WarningAmber className="text-yellow-400" />;
      }}
      transition={Bounce}
      limit={1}
    />
  );
};

export default Toast;
export * from "./hook";
